(() => {
  'use strict';
  const root = document.querySelector('[data-tcdkit-kit-builder]');
  const replay = root?.querySelector('[data-tcdkit-guide-start]');
  if (!root || !replay || root.dataset.guideReady) return;
  root.dataset.guideReady = 'true';
  let copy;
  try { copy = JSON.parse(root.querySelector('[data-tcdkit-guide-copy]').textContent); } catch { return; }
  const seenKey = 'tcdkit-demo-seen-v2';
  let active = false;
  let stage = 0;
  let snapshot = {};
  let target;
  let frame = 0;
  let originalFocus;
  let originalScroll = 0;
  let originalInert = false;
  const overlay = document.createElement('div');
  overlay.className = 'tcdkit-guide-overlay';
  overlay.hidden = true;
  overlay.innerHTML = '<div class="tcdkit-guide-shade"></div>'.repeat(4) + '<div class="tcdkit-guide-ring" aria-hidden="true"></div><div class="tcdkit-guide-arrow" aria-hidden="true"></div><section class="tcdkit-guide-panel" role="dialog" aria-modal="true" aria-labelledby="tcdkit-guide-title" aria-describedby="tcdkit-guide-description" tabindex="-1"><button type="button" class="tcdkit-guide-close" data-guide-close>×</button><div aria-live="polite" aria-atomic="true"><p class="tcdkit-guide-counter" data-guide-counter></p><h2 id="tcdkit-guide-title"></h2><p id="tcdkit-guide-description" data-guide-copy></p></div><div class="tcdkit-guide-actions"><button type="button" class="tcdkit-guide-skip" data-guide-close></button><button type="button" class="tcdkit-guide-next"></button></div></section>';
  document.body.append(overlay);
  const panel = overlay.querySelector('.tcdkit-guide-panel');
  const next = overlay.querySelector('.tcdkit-guide-next');
  const shades = [...overlay.querySelectorAll('.tcdkit-guide-shade')];
  const ring = overlay.querySelector('.tcdkit-guide-ring');
  const arrow = overlay.querySelector('.tcdkit-guide-arrow');
  overlay.querySelector('.tcdkit-guide-close').setAttribute('aria-label', copy.close);
  overlay.querySelector('.tcdkit-guide-skip').textContent = copy.skip;
  const clamp = (value, min, max) => Math.max(min, Math.min(Math.max(min,max),value));
  function command(action, detail = {}) { root.dispatchEvent(new CustomEvent('tcdkit:demo',{detail:{action,...detail}})); }
  function headerHeight() {
    const rect = document.querySelector('[data-tcd-header]')?.getBoundingClientRect();
    return rect ? Math.max(0,Math.min(rect.height,window.innerHeight / 3)) : 0;
  }
  function box(node,left,top,width,height) {
    Object.assign(node.style,{left:`${left}px`,top:`${top}px`,width:`${Math.max(0,width)}px`,height:`${Math.max(0,height)}px`});
  }
  function position() {
    frame = 0;
    if (!active || !target) return;
    const raw = target.getBoundingClientRect();
    const w = document.documentElement.clientWidth;
    const h = window.innerHeight;
    const margin = 12;
    const gap = 16;
    const safeTop = headerHeight()+12;
    const tipWidth = panel.offsetWidth;
    const tipHeight = panel.offsetHeight;
    const left = clamp(raw.left-7,4,w-12);
    const right = clamp(raw.right+7,left+8,w-4);
    const side = w-right >= tipWidth+gap+margin ? 'right' : left >= tipWidth+gap+margin ? 'left' : '';
    const maxSpot = side ? h-safeTop-margin : Math.max(72,h-safeTop-tipHeight-gap-margin);
    const top = clamp(raw.top-7,safeTop,h-margin-Math.min(72,maxSpot));
    const bottom = clamp(raw.bottom+7,top+8,Math.min(h-margin,top+maxSpot));
    let x;
    let y;
    let arrowX;
    let arrowY;
    if(side) {
      x=side==='right' ? right+gap : left-gap-tipWidth;
      y=clamp((top+bottom-tipHeight)/2,safeTop,h-tipHeight-margin);
      arrowX=side==='right' ? x-6 : x+tipWidth-6;
      arrowY=clamp((top+bottom)/2-6,y+16,y+tipHeight-22);
    } else {
      x=clamp((left+right-tipWidth)/2,margin,w-tipWidth-margin);
      if(bottom+gap+tipHeight <= h-margin) {
        y=bottom+gap;
        arrowY=y-6;
      } else if(top-gap-tipHeight >= safeTop) {
        y=top-gap-tipHeight;
        arrowY=y+tipHeight-6;
      } else {
        y=clamp(bottom+gap,safeTop,h-tipHeight-margin);
        arrowY=y-6;
      }
      arrowX=clamp((left+right)/2-6,x+18,x+tipWidth-24);
    }
    Object.assign(panel.style,{left:`${x}px`,top:`${y}px`});
    Object.assign(arrow.style,{left:`${arrowX}px`,top:`${arrowY}px`});
    box(shades[0],0,0,w,top);
    box(shades[1],0,top,left,bottom-top);
    box(shades[2],right,top,w-right,bottom-top);
    box(shades[3],0,bottom,w,h-bottom);
    box(ring,left,top,right-left,bottom-top);
  }
  function schedulePosition() { if(active && !frame) frame=requestAnimationFrame(position); }
  function show(index) {
    stage=clamp(index,0,4);
    command('show',{stage});
    const keys=['brand','platform','tools','power','review'];
    const key=keys[stage];
    const selectors=['.tcdkit-mode-options','.tcdkit-platform-grid','[data-tcdkit-tool-grid]','[data-tcdkit-power-grid]','.tcdkit-kit-checkout-box'];
    target=root.querySelector(selectors[stage]);
    if(!target) { close(); return; }
    overlay.querySelector('[data-guide-counter]').textContent=copy.steps[stage];
    overlay.querySelector('#tcdkit-guide-title').textContent=copy[`${key}_title`];
    const detail=snapshot.mode==='both' && ['platform','tools','power'].includes(key) ? `${key}_both` : snapshot.mode==='metabo' && key==='platform' ? 'platform_metabo' : `${key}_copy`;
    overlay.querySelector('[data-guide-copy]').textContent=copy[detail];
    next.textContent=stage===4 ? copy.done : copy.next;
    next.disabled=false;
    window.scrollTo({top:Math.max(0,window.scrollY+target.getBoundingClientRect().top-headerHeight()-24),behavior:'instant'});
    position();
    next.focus({preventScroll:true});
  }
  function close(getStarted = false) {
    if(!active) return;
    active=false;
    command('end');
    root.inert=originalInert;
    overlay.hidden=true;
    document.body.classList.remove('tcdkit-guide-active');
    const top=getStarted ? window.scrollY+root.querySelector('.tcdkit-mode-options').getBoundingClientRect().top-headerHeight()-24 : originalScroll;
    window.scrollTo({top:Math.max(0,top),behavior:'instant'});
    if(getStarted) root.querySelector('[data-tcdkit-mode][aria-pressed="true"]')?.focus({preventScroll:true});
    else if(originalFocus?.isConnected && originalFocus.getClientRects().length) originalFocus.focus({preventScroll:true});
    else replay.focus({preventScroll:true});
  }
  function start() {
    if(active || snapshot.busy) return;
    originalFocus=document.activeElement;
    originalScroll=window.scrollY;
    originalInert=root.inert;
    command('begin');
    if(!snapshot.demo) return;
    active=true;
    root.inert=true;
    overlay.hidden=false;
    document.body.classList.add('tcdkit-guide-active');
    try { localStorage.setItem(seenKey,'1'); } catch {}
    show(0);
  }
  function onKey(event) {
    if(!active) return;
    if(event.key==='Escape') { event.preventDefault(); close(); return; }
    if(event.key!=='Tab') return;
    const nodes=[...panel.querySelectorAll('button:not(:disabled)')];
    const index=nodes.indexOf(document.activeElement);
    const chosen=event.shiftKey ? (index<=0 ? nodes.length-1 : index-1) : (index+1)%nodes.length;
    event.preventDefault();
    nodes[chosen].focus();
  }
  function onState(event) { snapshot=event.detail; }
  function unload(event) {
    if(!event.target?.contains(root)) return;
    close();
    observer.disconnect();
    if(frame) cancelAnimationFrame(frame);
    window.removeEventListener('scroll',schedulePosition);
    window.removeEventListener('resize',schedulePosition);
    window.removeEventListener('pagehide',onPageHide);
    document.removeEventListener('keydown',onKey);
    document.removeEventListener('shopify:section:unload',unload);
    root.removeEventListener('tcdkit:guide-state',onState);
    overlay.remove();
  }
  function onPageHide() { close(); }
  next.addEventListener('click',()=>stage===4 ? close(true) : show(stage+1));
  overlay.querySelectorAll('[data-guide-close]').forEach(button=>button.addEventListener('click',()=>close()));
  replay.addEventListener('click',start);
  root.addEventListener('tcdkit:guide-state',onState);
  document.addEventListener('keydown',onKey);
  window.addEventListener('scroll',schedulePosition,{passive:true});
  window.addEventListener('resize',schedulePosition,{passive:true});
  window.addEventListener('pagehide',onPageHide);
  const observer=new ResizeObserver(schedulePosition);
  observer.observe(root);
  observer.observe(panel);
  document.addEventListener('shopify:section:unload',unload);
  root.dispatchEvent(new CustomEvent('tcdkit:guide-request'));
  let seen=false;
  try { seen=localStorage.getItem(seenKey)==='1'; } catch {}
  if(!seen && !window.Shopify?.designMode) start();
})();
